export const environment = {
  production: false,
  environmentName: 'development',
  i18nVersion: '2026.05.31',
  authUrl: 'https://dev-auth.simplified.com.co',
  clientId: 'facilchat-ui',
  clientSecret: 'facilchat-ui',
  redirectUri: 'https://dev-facilchat.simplified.com.co/callback',
  postLogoutRedirectUri: 'https://dev-facilchat.simplified.com.co',
  apiBaseUrl: 'https://webhooks.simplified.com.co',
  api: 'https://webhooks.simplified.com.co/api/v1/',
  tenantHeaderName: 'x-tenant-id',
  tenantId: '',
  scope: 'chats professionals services tenants appointments clients_bot products orders customers password:change-own template:send template:read template:write health'
};
